let weekend = ['', '']
export const WORDS = {
  seventh: ['meses', 'lejos', 'quien', ...weekend, 'trece', 'llegar'],
  eighth: ['meses'],
}
